import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2500c982"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "page_item_container" }
const _hoisted_2 = ["onClick", "id"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { id: "page_item_sep_v" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NewsPage = _resolveComponent("NewsPage")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          onClick: ($event: any) => (_ctx.handleSwitchTab(index)),
          key: `titile_${index}`,
          id: 
        _ctx.selectedIndex == index
          ? 'page_item_selected_title'
          : 'page_item_normal_title'
      
        }, _toDisplayString(item.title), 9, _hoisted_2))
      }), 128))
    ]),
    _hoisted_3,
    _createVNode(_component_NewsPage, {
      items: _ctx.pages[_ctx.selectedIndex].details
    }, null, 8, ["items"])
  ], 64))
}